export enum AvailableCourses {
    KED = "KED",
    KED_V2 = "KED_V2",
    PED = "PED",
    ZN = "ZN",
    SPC = "SPC",
}